// User preferences
export const SET_USER_PREFERENCE = 'SET_USER_PREFERENCE';
